module.exports = __webpack_public_path__ + "img/6_118.3bc289fd.png";